import { useRef } from 'react'
import { motion, useInView } from 'framer-motion'

const pillars = [
  { title: 'Sistema Nervoso', desc: 'Stress, energia, recupero, attivazione e gestione del carico mentale.', color: '#8b5cf6', icon: '⚡' },
  { title: 'Corpo', desc: 'Movimento, postura, presenza fisica e sicurezza nel corpo.', color: '#ef4444', icon: '◆' },
  { title: 'Focus', desc: 'Meno rumore mentale. Più direzione.', color: '#00d4ff', icon: '◎' },
  { title: 'Azione', desc: 'Micro missioni concrete. Piccoli passi. Progressione reale.', color: '#facc15', icon: '▶' },
]

export default function MethodSection() {
  const sectionRef = useRef(null)
  const isInView = useInView(sectionRef, { once: true, margin: '-100px' })

  return (
    <section id="metodo" ref={sectionRef} className="relative w-full py-12 md:py-18 px-4" style={{ background: '#050510' }}>
      <div className="absolute inset-0 pointer-events-none"
        style={{ background: 'radial-gradient(ellipse at 50% 50%, rgba(139,92,246,0.05) 0%, transparent 55%)' }}
      />
      <div className="max-w-5xl mx-auto relative z-10">
        <motion.div className="text-center mb-14"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold text-nerd-white mb-4">
            Non motivazione.{' '}
            <span className="text-gradient">Sistema.</span>
          </h2>
          <p className="text-nerd-gray text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
            Nerd Coach lavora su mente, corpo e comportamento. Non ti chiede di rinnegare ciò che ami. Ti aiuta a non usarlo come nascondiglio.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 relative">
          {/* Connecting lines */}
          <div className="hidden sm:block absolute top-1/2 left-[25%] right-[25%] h-[1px]"
            style={{ background: 'linear-gradient(90deg, transparent, rgba(139,92,246,0.2), rgba(0,212,255,0.2), transparent)' }}
          />
          <div className="hidden sm:block absolute left-1/2 top-[25%] bottom-[25%] w-[1px]"
            style={{ background: 'linear-gradient(180deg, transparent, rgba(139,92,246,0.2), rgba(0,212,255,0.2), transparent)' }}
          />

          {pillars.map((p, i) => (
            <motion.div
              key={p.title}
              className="manga-panel rounded-xl p-7 text-center relative group"
              initial={{ opacity: 0, y: 50 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.2 + i * 0.15, ease: [0.22, 1, 0.36, 1] }}
            >
              <div className="mx-auto w-10 h-10 rounded-full bg-nerd-bg border flex items-center justify-center mb-4"
                style={{ borderColor: `${p.color}40`, boxShadow: `0 0 15px ${p.color}15` }}
              >
                <span className="text-sm font-display font-bold" style={{ color: p.color }}>{p.icon}</span>
              </div>
              <h3 className="font-display text-xl font-bold text-nerd-white mb-2">{p.title}</h3>
              <p className="text-nerd-gray text-sm leading-relaxed">{p.desc}</p>
              <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-1/2 h-[1px] bg-gradient-to-r from-transparent via-nerd-purple/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
